import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Load PrimeReact styles FIRST
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

// Load PrimeReact theme
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";

// Load Tailwind CSS
import './tailwind.css';

// Load minimal CSS overrides
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);